export default __webpack_public_path__ + "static/media/image5.314ce1be.png";